/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./JoinOrStart.vue?vue&type=template&id=d0b83f04&scoped=true&"
import script from "./JoinOrStart.vue?vue&type=script&lang=js&"
export * from "./JoinOrStart.vue?vue&type=script&lang=js&"
import style0 from "./JoinOrStart.vue?vue&type=style&index=0&id=d0b83f04&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b83f04",
  null
  
)

export default component.exports